const VuexGlobalActionPlugin ={

    install(app, store){
        app.config.globalProperties.$showToast = (payload)=>{
            return store.dispatch('toast/showToast', payload)
        }
    }
}

export default VuexGlobalActionPlugin